import { JsonResponse, SupersetClient } from '@aibi-ui/core';
import { ChatJustify } from 'src/types/conversation';

/** 获取指定对话的佐证材料 */
export const getChatJustifyDataAPI = (
  searchParams: ChatJustify.ListQuery,
): Promise<JsonResponse<{ result: ChatJustify.DataItem[] }>> =>
  SupersetClient.get({ endpoint: '/api/v1/chat/justify/data', searchParams, showErrorToast: false });

/** 获取指定数据下钻结果 */
export const postChatJustifyDrillAPI = (
  jsonPayload: ChatJustify.DrillQuery,
): Promise<JsonResponse<{ result: ChatJustify.DrillData }>> =>
  SupersetClient.post({ endpoint: '/api/v1/chat/justify/drill', jsonPayload });
